export default "__VITE_ASSET__CXGNQ_RB__"